
import rules from './rules';
import Form from './components/form/index';
import Input from './components/input/index';
import Select from './components/select/index';
import Textarea from './components/textarea/index';
import Button from './components/button/index';
import ValidationContext, { ValidationContextConsumer, ValidationContextProvider } from './contexts/ValidationContext';
import inputFactory from './factories/inputfactory';
import selectFactory from './factories/selectfactory';
import textareaFactory from './factories/textareafactory';

const Validation = {
  rules,
  components: {
    Form,
    Input,
    Select,
    Textarea,
    Button
  },
  contexts: {
    ValidationContext,
    ValidationContextConsumer,
    ValidationContextProvider
  },
  factories: {
    inputFactory,
    selectFactory,
    textareaFactory
  }
};

export default Validation;
